module.exports = __webpack_public_path__ + "static/media/contact-bg.d6c6571b.jpg";